import React from 'react';
import { Visibility } from '@mui/icons-material';
import { Stack, Tooltip, IconButton } from '@mui/material';

import { useEventIdParam } from '../../../hooks';

interface Props {
  id: string;
}

export const ActionsCell = ({ id }: Props) => {
  const { openEvent } = useEventIdParam();

  return (
    <Stack direction="row" alignItems="center" justifyContent="center">
      <Tooltip title="Open event">
        <IconButton color="primary" size="small" onClick={() => openEvent(id)}>
          <Visibility fontSize="small" color="primary" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
